import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e609211"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请填写关联的Booking No.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_price_voyage_choose = _resolveComponent("price-voyage-choose")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_page_list, {
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
      onHandleGet: _ctx.handleGet,
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick,
      onHandleChangeWhere: _ctx.handleChangeWhere,
      onHandleRowDbClick: _ctx.handleRowDbClick
    }, {
      "dynamic-search-customize": _withCtx(({ model }) => [
        (model.Where.Prop == 'DynamicSearch_ServiceRemark')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 0,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.serviceRemarks,
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : (model.Where.Prop == 'DynamicSearch_CreatedCompanyUserId')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 1,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.createdCompanyUsers,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : (model.Where.Prop == 'DynamicSearch_Status')
              ? (_openBlock(), _createBlock(_component_miezz_select, {
                  key: 2,
                  modelValue: model.Where.Value,
                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                  options: _ctx.EnumPriceQuotationSheetStatusOption,
                  clearable: false,
                  number: true
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
              : (model.Where.Prop.startsWith('Voyage'))
                ? (_openBlock(), _createBlock(_component_price_voyage_choose, {
                    key: 3,
                    modelValue: model.Where.Value,
                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : (model.Where.Prop.startsWith('SailingDate'))
                  ? (_openBlock(), _createBlock(_component_el_date_picker, {
                      key: 4,
                      modelValue: model.Where.Value,
                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                      type: "date",
                      format: "YYYY/MM/DD",
                      "value-format": "YYYY/MM/DD",
                      class: "form-item-date"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createBlock(_component_miezz_select, {
                      key: 5,
                      modelValue: model.Where.Value,
                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                      options: _ctx.searchs[model.Where.Prop],
                      remote: true,
                      remoteMethod: (q) => _ctx.querySearch(model.Where.Prop, q),
                      onFocus: ($event: any) => (_ctx.querySearch(model.Where.Prop, ''))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "remoteMethod", "onFocus"]))
      ]),
      column: _withCtx(({ model, row }) => [
        (model.Prop == 'BookingNo' && row.PoolId)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "javascript:void",
              onClick: ($event: any) => (_ctx.handleEditBookingNo(row))
            }, _toDisplayString(row.BookingNo), 9, _hoisted_1))
          : (model.Prop == 'InquiryDescription')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (row.InquiryDescription)
                  ? (_openBlock(), _createBlock(_component_el_popover, {
                      key: 0,
                      placement: "top-start",
                      "popper-class": "popover-tooltip",
                      effect: "dark",
                      trigger: "hover"
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: row.InquiryDescription
                        }, null, 8, ["text"])
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.InquiryDescription.split('\n'), (item, i) => {
                          return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(item), 1))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, "--"))
              ]))
            : _createCommentVNode("", true),
        (
          model.Prop == 'Stage' &&
          _ctx.powerCodes.contains('PriceManagement_QuotationSheet_ChangeStage')
        )
          ? (_openBlock(), _createBlock(_component_miezz_button, {
              key: 2,
              model: {
          Code: 'stage',
          Label:
            _ctx.EnumPriceQuotationSheetStageOption.firstOrDefault(
              (it) => it.Value == row.Stage
            )?.Label ?? '暂无数据',
          Type: 'text',
          Size: 'small',
          Options: _ctx.EnumPriceQuotationSheetStageOption.map((it) => {
            return {
              Code: it.Value?.toString(),
              Label: it.Label,
              Size: 'small',
            };
          }),
        },
              style: {"color":"#fe995b"},
              onHandleClick: (arg1, arg2) => _ctx.handleRowButtonClick(arg1, row, arg2)
            }, null, 8, ["model", "onHandleClick"]))
          : (model.Prop == 'Stage')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.EnumPriceQuotationSheetStageOption.firstOrDefault(
            (it) => it.Value == row.Stage
          )?.Label ?? "暂无数据"), 1))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick", "onHandleChangeWhere", "onHandleRowDbClick"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalWin,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalWin) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ref-form-win",
          rules: _ctx.modalRuleWin,
          model: _ctx.modalDataWin,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createVNode(_component_el_form_item, {
              prop: "PoolId",
              label: "Booking No."
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.modalDataWin.PoolId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalDataWin.PoolId) = $event)),
                  options: _ctx.pools,
                  clearable: false
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}